// extracted by mini-css-extract-plugin
export var formContainer = "_ie-0";
export var message = "_ie-1";